<template>
  <div>
    <div class="count">总数：{{ count }}</div>
    <div class="container">
      <div id="echart" />
    </div>
  </div>
</template>
<script>
import { alldatalist } from '@/api/providerAccountManagement/servicePorviderList1.js'
export default {
  data() {
    return {
      arr: [],
      arrs: [],
      count: null
    }
  },
  // 页面初始化挂载dom
  mounted() {
    console.log('111')
    // this.$nextTick(() => {
    //   //  执行echarts方法
    //   this.getLoadEcharts()
    // })
    // this.getLoadEcharts()
  },
  methods: {
    getLoadEcharts(data) {
      var myChart = this.$echarts.init(
        document.getElementById('echart')
      )
      console.log('datas', data)
      // this.fileList = data.map(item => {
      //   return { item.count }
      // })
      for (let i = 0; i < data.length; i++) {
        this.arr.push(data[i].count)
      }
      for (let i = 0; i < data.length; i++) {
        this.arrs.push(data[i].date)
      }
      console.log('this.arr', this.arr)
      var option = {
        color: '#96d2e9', // 设定实线点的颜色
        title: {
          // text: 'Stacked Line'
        },
        minInterval: 1,
        tooltip: {
          trigger: 'axis'
        },
        // legend: {
        //   data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
        // },
        // grid: {
        //   left: '3%',
        //   right: '4%',
        //   bottom: '3%',
        //   containLabel: true
        // },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.arrs
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            // name: 'Email',
            type: 'line',
            stack: 'Total',
            data: this.arr
          }
          // {
          //   name: 'Union Ads',
          //   type: 'line',
          //   stack: 'Total',
          //   data: [220, 182, 191, 234, 290, 330, 310]
          // },
          // {
          //   name: 'Video Ads',
          //   type: 'line',
          //   stack: 'Total',
          //   data: [150, 232, 201, 154, 190, 330, 410]
          // },
          // {
          //   name: 'Direct',
          //   type: 'line',
          //   stack: 'Total',
          //   data: [320, 332, 301, 334, 390, 330, 320]
          // },
          // {
          //   name: 'Search Engine',
          //   type: 'line',
          //   stack: 'Total',
          //   data: [820, 932, 901, 934, 1290, 1330, 1320]
          // }
        ]
      }
      myChart.setOption(option)
    },
    async send(id, type) {
      console.log('---', id, type)
      this.getlist(id, type)
    },
    // 数据接口
    async getlist(id, type) {
      const data = await alldatalist({
        kf_open_id: id,
        type: type
      })
      console.log('datarrrr', data)
      this.getLoadEcharts(data.data.countData)
      this.count = data.data.total
      // this.$nextTick(() => {
      // //  执行echarts方法
      //   this.getLoadEcharts(data.data.countData)
      // })
      // console.log('data', data.data.countData)
    }
  }
}
</script>
<style scoped>
.container{
    width: 800px;
    height: 500px;
    margin-left: 30px;
}
#echart{
    width: 100%;
    height: 100%;
}
.count{

}
@media (max-width: 768px){
  .container{
    width: 70vw;
    height: 50vw;
  }
}
</style>
